import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPolicy, resetPolicy } from "../redux/policySlice";

export default function usePolicy(slug) {
    const dispatch = useDispatch();

    const { data: policy, loading, error } = useSelector(
        (state) => state.policy
    );

    useEffect(() => {
        if (!slug) return;

        dispatch(fetchPolicy(slug));

        return () => {
            dispatch(resetPolicy());
        };
    }, [dispatch, slug]);

    useEffect(() => {
        if (policy?.title) {
            document.title = `Obsessions - ${policy.title}`;
        }
    }, [policy]);

    return { policy, loading, error };
}
